import {MenuButton, useMenu} from "../../menu/Menu";
import {makeViewInStripeAction, makeChangeCompanyResellerAction, makeDeleteAction} from "../../../factories/MenuItemFactory";
import {Company} from "../../../models/Company";
import React from "react";
import {useRbac} from "@gsb/react-rbac";
import {actions} from "../../../rbac";

interface Props {
    company: Company;
    onViewInStripeClicked: () => void;
    onChangeResellerClicked: () => void;
    onDeleteClicked: () => void;
}

const makeCompanyMenuItems = (onViewInStripeClicked: () => void, canLinkStripeCustomer: boolean) => (
    canLinkStripeCustomer
        ? [makeViewInStripeAction(onViewInStripeClicked)]
        : []
)

export function CompanyMenuButton({ company, onViewInStripeClicked, onChangeResellerClicked, onDeleteClicked }: Props) {
    const { can } = useRbac();

    const menuItems = makeCompanyMenuItems(onViewInStripeClicked, can(actions.company.linkStripeCustomer));

    if(can(actions.company.updateReseller)){
        menuItems.push(makeChangeCompanyResellerAction(onChangeResellerClicked));
    }

    if(can(actions.company.delete)){
        menuItems.push(makeDeleteAction(onDeleteClicked));
    }

    return (
        <MenuButton items={menuItems}/>
    )
}

export function useCompanyMenu(onViewCompanyInStripeClicked: (company: Company) => void) {
    const { can } = useRbac();
    const { menu, openMenu } = useMenu();

    return {
        companyMenu: menu,
        openCompanyMenu: (element: HTMLElement, company: Company) => {
            const items = makeCompanyMenuItems(
                () => onViewCompanyInStripeClicked(company),
                can(actions.company.linkStripeCustomer)
            );
            openMenu(element, items)
        }
    }
}
